const rulesText = (
    required=false,
    min=0,
    max=null,
    empty=true,
    number=false
) => {
    return {
        required:required,
        min:min,
        max:max,
        empty:empty,
        number:number,
    }
}

export default rulesText;